import styled from "styled-components";

export const CmpNumberInput = styled.div`
`;
